import { action } from './index'
import { CONTESTS_FETCH_REQUEST, CONTESTS_FETCH_SUCCESS } from './constants'
import { IContest } from '../reducers/contests'

export const fetchContests = () => {
  return action(CONTESTS_FETCH_REQUEST)
}

export const addContests = (contests: IContest[]) => {
  return action(CONTESTS_FETCH_SUCCESS, contests)
}

export type ContestsActions = ReturnType<
  typeof fetchContests | typeof addContests
>
